import { render, staticRenderFns } from "./PasswordLogin.vue?vue&type=template&id=f6cfca4e&scoped=true"
import script from "./PasswordLogin.vue?vue&type=script&lang=js"
export * from "./PasswordLogin.vue?vue&type=script&lang=js"
import style0 from "./PasswordLogin.vue?vue&type=style&index=0&id=f6cfca4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6cfca4e",
  null
  
)

export default component.exports